import { SET_COMMUNITIES_CONTEXT } from '../actions/set-communities-context';
import { APPLICATION_ADDED } from '../actions/application-added';
import { APPLICATION_DELETED } from '../actions/application-deleted';

export default function experiments(state = {}, action) {
  switch (action.type) {
    case SET_COMMUNITIES_CONTEXT:
      return action.payload;
    case APPLICATION_ADDED: {
      const { appDefinitionId, instanceId } = action.payload;
      return { ...state, [appDefinitionId]: { ...state[appDefinitionId], isInstalled: true, instanceId } };
    }
    case APPLICATION_DELETED: {
      const { appDefinitionId } = action.payload;
      return { ...state, [appDefinitionId]: { ...state[appDefinitionId], isInstalled: false, instanceId: null } };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/communities-context.js